/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import VehicleTypeCard from "./VehicleTypeCard";
import PassengerCard from "./PassengerCard";
import { PaxIcon, LuggageIcon } from "../../icons";
import {
  getTotalPaxCount,
  getTotalLuggageCount,
} from "../../../utils/Calculator";
import { MotionModal, ModalCloseButton } from "../../motion";

const CarSelection = ({
  //to vehicleTypeCard - start
  vehicleTypeNames,
  applyToTheEquation,

  //to vehicleTypeCard - end
  index,
  applyPaxAndLugageToTheEquation,
  idScroll,
  currentMaxPassenger,
  currentMaxLugage,
  clickedManyVehicleType,
  isEditBooking = false,
  // Pre-selected Meet & Assist, folded into every card's price. Same figure for
  // every vehicle -- it depends on the route, not the car.
  meetAssistPrice = 0,
}) => {
  const { t, } = useTranslation();
  const [lugageVisible, setLugageVisible] = useState(false);
  const wrapperRef = useRef(null);
  const modalRef = useRef(null);
  const vehicleListRef = useRef(null);
  const paxFormRef = useRef(null);
  const [passengerVisible, setPassangerVisible] = useState(false);
  const [showVehicleWarning, setShowVehicleWarning] = useState(false);
  const [pax, setPax] = useState({
    adult: 0,
    child: 0,
    toddler: 0,
    baby: 0,
  });
  const [lugage, setLugage] = useState({
    cabinSize: 0,
    checkinSize: 0,
  });
  const [totalPax, setTotalPax] = useState(0);
  const [totalLugage, setTotalLugage] = useState(0);
  const [styleSelectedVehicle, setStyleSelectedVehicle] = useState([]);
  const [clickedVt, setClickedVt] = useState(null);
  const [useModal, setShowModal] = useState(false);
  const [maxLuggageByPax, setMaxLuggageByPax] = useState(0);

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const scrollToVehicleList = () => {
    vehicleListRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const scrollToPaxForm = () => {
    paxFormRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const handlePaxLuggageClick = (toggleFn, otherToggleFn, currentVisible) => {
    if (clickedVt === null) {
      setShowVehicleWarning(true);
      scrollToVehicleList();
      setTimeout(() => setShowVehicleWarning(false), 3000);
      return;
    }
    toggleFn(!currentVisible);
    otherToggleFn(false);
  };

  useEffect(() => {
    let resultArray = [];
    for (let i = 0; i < vehicleTypeNames.length; i++) {
      resultArray.push("");
    }

    setStyleSelectedVehicle(resultArray);
  }, []);

  useEffect(() => {
    if (clickedVt !== null) {
      const maxLuggage = clickedVt?.calculationRules.find(item => item.pax === (totalPax === 0 ? 1 : totalPax))?.cabinLuggage ?? 0;
      setMaxLuggageByPax(maxLuggage);
    }
  }, [clickedVt, totalPax])

  const setStyle = (ind) => {
    let resultArray = [];
    for (let i = 0; i < vehicleTypeNames.length; i++) {
      resultArray.push("");
    }

    resultArray[ind] = "selected-vehicle-card";

    setStyleSelectedVehicle(resultArray);
    setPax(null);
    setLugage(null);
    setTotalLugage(0);
    setTotalPax(0);
  };

  /**
   * * PAX selection popup closing function. Click anywhere outside the popup modal to close it.
   */
  useEffect(() => {
    function handleClickOutside(event) {
      const insideWrapper = wrapperRef.current && wrapperRef.current.contains(event.target);
      const insideModal = modalRef.current && modalRef.current.contains(event.target);
      if (!insideWrapper && !insideModal) {
        setPassangerVisible(false);
        setLugageVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /**
   * * Show and hide pax panel / modal
   */
  const setPaxAndLuggaePannalVisibility = (status) => {
    setPassangerVisible(status);
  };

  const setLugageFormDataToState = (formData) => {
    var summedLugage = getTotalLuggageCount(formData);
    setTotalLugage(summedLugage);
    setLugage(formData);
  };

  const setPaxFormDataToState = (formData) => {
    var summedPax = getTotalPaxCount(formData);
    setTotalPax(summedPax);
    setPax(formData);
  };

  return (
    <div className="container px-md-3 tw:!mt-24 tw:md:!mt-0 tw:lg:!mt-0" id={idScroll}>
      <div className="row mb-3 gy-4 d-flex align-items-center justify-content-center">
        <div className="col-auto text-center">
          <div className="tw:font-libre-caslon-display tw:text-[16px] tw:md:!text-[26px] tw:capitalize">
            {t("Discover.SelectVehicle.Multiple.Car")} #{index + 1}
          </div>
        </div>
        <div className="col px-0">
          <hr />
        </div>
      </div>
      <div className="row gy-4 mb-3" ref={vehicleListRef}>
        {showVehicleWarning && (
          <div className="col-12">
            <div className="alert alert-warning text-center mb-3" role="alert">
              {t("Please select a vehicle first")}
            </div>
          </div>
        )}
        <div className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:2xl:grid-cols-3 tw:md:[grid-auto-rows:1fr] tw:gap-x-4 tw:gap-y-4 tw:md:gap-y-[22px]">
          {vehicleTypeNames.map((vt, i = 0) =>
            clickedManyVehicleType.length === 0 ? (
              <VehicleTypeCard
                key={vt._id}
                index={i}
                onClick={(e) => {
                  applyToTheEquation(vt, index);
                  setStyle(i);
                  setClickedVt(vt);
                  setShowVehicleWarning(false);
                  setTimeout(() => scrollToPaxForm(), 300);
                }}
                vehicle_type={vt}
                styleSelectedVehicle={styleSelectedVehicle[i]}
                handleShowModal={handleShowModal}
                isEditBooking={isEditBooking}
                price={vt.price}
                meetAssistPrice={meetAssistPrice}
              />
            ) : (
              <VehicleTypeCard
                key={vt._id}
                onClick={(e) => {
                  applyToTheEquation(vt, index);
                  setStyle(i);
                  setClickedVt(vt);
                  setShowVehicleWarning(false);
                  setTimeout(() => scrollToPaxForm(), 300);
                }}
                vehicle_type={vt}
                styleSelectedVehicle={styleSelectedVehicle[i]}
                handleShowModal={handleShowModal}
                disabledCard={
                  clickedManyVehicleType.filter((item) => item === vt.typename)
                    .length >= vt.count
                }
                isEditBooking={isEditBooking}
                price={vt.price}
                meetAssistPrice={meetAssistPrice}
              />
            )
          )}
        </div>
      </div>

      <div className="row gy-4 mb-5" ref={paxFormRef}>
        <div className="col-12">
          <div className="card h-100 custom-card-passenger d-none d-lg-block">
            <div className="card-body">
              <div className="container">
                <div ref={wrapperRef} className="row d-flex align-items-center justify-content-center">
                  <div className="col">
                    <p className="tw:md:!text-[15px] tw:capitalize tw:!m-0">
                      {t("Discover.SelectVehicle.Multiple.Car.PaxDetail")}
                    </p>
                  </div>
                  <div className="col-auto">
                    <div className="form-floating position-relative">
                      <input
                        name="pax"
                        type="number"
                        id="passengers"
                        placeholder="Passengers"
                        aria-label="Passengers"
                        value={totalPax === 0 ? "" : totalPax}
                        onClick={() => {
                          handlePaxLuggageClick(setPassangerVisible, setLugageVisible, passengerVisible);
                        }}
                        readOnly={true}
                        className={"form-control form-control-icon"}
                      />
                      {passengerVisible && (
                        <div
                          className="position-absolute passanger-card-position"
                        // style={{ right: "30%" }}
                        >
                          <PassengerCard
                            setPaxPanel={setPaxAndLuggaePannalVisibility}
                            setFormDataToState={setPaxFormDataToState}
                            passengerFormData={pax}
                            passangerForm={true}
                            luggageForm={false}
                            passangerMax={currentMaxPassenger}
                            clickedVt={clickedVt}
                          />
                        </div>
                      )}

                      <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                        <div className="d-flex justify-content-center">
                          <PaxIcon />
                        </div>
                      </span>
                      <label htmlFor="floatingInput" className="label-icon">
                        {t("Passengers")}
                      </label>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="form-floating position-relative">
                      <input
                        value={totalLugage === 0 ? "" : totalLugage}
                        onClick={() => {
                          handlePaxLuggageClick(setLugageVisible, setPassangerVisible, lugageVisible);
                        }}
                        readOnly={true}
                        className={"form-control form-control-icon"}
                      />

                      <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                        <div className="d-flex justify-content-center">
                          <LuggageIcon />
                        </div>
                      </span>
                      {lugageVisible && (
                        <div className="position-absolute passanger-card-position">
                          <PassengerCard
                            setPaxPanel={setPaxAndLuggaePannalVisibility}
                            setFormDataToState={setLugageFormDataToState}
                            passangerForm={false}
                            luggageForm={true}
                            passengerFormData={lugage}
                            lugageMax={currentMaxLugage}
                            clickedVt={clickedVt}
                            currentPax={totalPax}
                          />
                        </div>
                      )}
                      <label className="label-icon">{t("Luggage")}</label>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="d-grid gap-2 d-md-block mt-auto">
                      <button
                        type="button"
                        onClick={(e) => {
                          applyPaxAndLugageToTheEquation(pax, lugage, index);
                        }}
                        className="btn btn-primary btn-sm rounded-3 px-4 d-flex align-items-center justify-content-center px-md-5 py-2"
                        style={{ height: 50 }}
                      >
                        <div className="d-flex align-items-center px-2 d-inline">
                          {t("Discover.Proceed.Multiple.Car")}
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {clickedVt !== null ? (
                <div className="row d-flex align-items-center gap-4 justify-content-center mt-3">
                  <div className="container">
                    <div className="col py-2 bg-gold-light-100 rounded-3 justify-content-center text-center">
                      {
                        `Maximum Luggage Capacity available for ${totalPax ?? "-"} passengers: ${clickedVt?.calculationRules?.find(rule => rule.pax === (totalPax === 0 ? 1 : totalPax))?.cabinLuggage ?? "-"} Cabin Size or ${clickedVt?.calculationRules?.find(rule => rule.pax === (totalPax === 0 ? 1 : totalPax))?.cabinLuggage / 2} Check-in Size`
                      }
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Passenger / luggage popup for multi-vehicle bookings */}
      <MotionModal
        show={useModal}
        onClose={handleCloseModal}
        maxWidthClassName="tw:sm:max-w-[500px] tw:lg:max-w-[800px]"
        panelClassName="border-top-gold"
      >
              {/* Ref used by the click-outside check that closes the pax/luggage pickers. */}
              <div ref={modalRef}>
                <div className="modal-body px-4">
                  <div className="row d-flex justify-content-end">
                    <ModalCloseButton isInline onClick={handleCloseModal} />
                  </div>
                  <p className="tw:text-[15px] tw:capitalize tw:!m-0 tw:!mb-3">
                    {t("Discover.SelectVehicle.Multiple.Car.PaxDetail")}
                  </p>
                  <div className="row gap-3 mt-3">
                    <div className="col-12">
                      <div className="form-floating position-relative">
                        <input
                          name="pax"
                          type="number"
                          id="modal-passengers"
                          placeholder="Passengers"
                          aria-label="Passengers"
                          value={totalPax === 0 ? "" : totalPax}
                          onClick={() => {
                            handlePaxLuggageClick(setPassangerVisible, setLugageVisible, passengerVisible);
                          }}
                          readOnly={true}
                          className={"form-control form-control-icon"}
                        />
                        {passengerVisible && (
                          <div className="position-absolute passanger-card-position">
                            <PassengerCard
                              setPaxPanel={setPaxAndLuggaePannalVisibility}
                              setFormDataToState={setPaxFormDataToState}
                              passengerFormData={pax}
                              passangerForm={true}
                              luggageForm={false}
                              passangerMax={currentMaxPassenger}
                              clickedVt={clickedVt}
                            />
                          </div>
                        )}
                        <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                          <div className="d-flex justify-content-center">
                            <PaxIcon />
                          </div>
                        </span>
                        <label htmlFor="modal-passengers" className="label-icon">
                          {t("Passengers")}
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating position-relative">
                        <input
                          name="luggage"
                          type="number"
                          id="modal-luggage"
                          placeholder="Luggage"
                          aria-label="Luggage"
                          value={totalLugage === 0 ? "" : totalLugage}
                          onClick={() => {
                            handlePaxLuggageClick(setLugageVisible, setPassangerVisible, lugageVisible);
                          }}
                          readOnly={true}
                          className={"form-control form-control-icon"}
                        />
                        <span className="position-absolute translate-middle-y top-50 start-10 p-1rem">
                          <div className="d-flex justify-content-center">
                            <LuggageIcon />
                          </div>
                        </span>
                        {lugageVisible && (
                          <div className="position-absolute passanger-card-position">
                            <PassengerCard
                              setPaxPanel={setPaxAndLuggaePannalVisibility}
                              setFormDataToState={setLugageFormDataToState}
                              passangerForm={false}
                              luggageForm={true}
                              passengerFormData={lugage}
                              lugageMax={currentMaxLugage}
                              clickedVt={clickedVt}
                              currentPax={totalPax}
                            />
                          </div>
                        )}
                        <label htmlFor="modal-luggage" className="label-icon">
                          {t("Luggage")}
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-grid gap-2 mt-auto">
                        <button
                          type="button"
                          onClick={(e) => {
                            handleCloseModal();
                            applyPaxAndLugageToTheEquation(pax, lugage, index);
                          }}
                          className="btn btn-primary btn-sm rounded-3 px-4 d-flex align-items-center justify-content-center py-2"
                          style={{ height: 50 }}
                        >
                          <div className="d-flex align-items-center px-2 d-inline">
                            {t("Discover.Proceed.Multiple.Car")}
                          </div>
                        </button>
                      </div>
                    </div>

                    {clickedVt !== null && (
                      <div className="col-12">
                        <div className="py-2 bg-gold-light-100 rounded-3 text-center">
                          {
                            `Maximum Luggage Capacity available for ${totalPax ?? "-"} passengers: ${clickedVt?.calculationRules?.find(rule => rule.pax === (totalPax === 0 ? 1 : totalPax))?.cabinLuggage ?? "-"} Cabin Size or ${clickedVt?.calculationRules?.find(rule => rule.pax === (totalPax === 0 ? 1 : totalPax))?.cabinLuggage / 2} Check-in Size`
                          }
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
      </MotionModal>
    </div>
  );
};

export default CarSelection;
